var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExport = function SvgExport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 17",
    strokeLinecap: "round",
    stroke: "#3d60d3"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3 -0.934)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,12v5.974a1.5,1.5,0,0,0,1.5,1.493h9A1.5,1.5,0,0,0,16,17.974V12",
    transform: "translate(0 -2.533)",
    fill: "none",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.026,4.987,11.013,2,8,4.987",
    transform: "translate(-1.013)",
    fill: "none",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 10,
    transform: "translate(10.026 1.934)",
    fill: "none",
    strokeLinejoin: "round"
  }))));
};
export default SvgExport;